import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ATTRIBUTE: 'attribute',
    ID: 'order.base.product.id',
    PRODUCTID: 'order.base.product.productid',
    PRODUCTCODE: 'order.base.product.prodcode',
    NAME: 'order.base.product.name',
    PRICE: 'order.base.product.price',
    COSTS: 'order.base.product.costs',
    REBATE: 'order.base.product.rebate',
    MEDIAURL: 'order.base.product.mediaurl',
    QUANTITY: 'order.base.product.quantity',
    POSITION: 'order.base.product.position',
    DESCRIPTION: 'order.base.product.description',
    STATUS: 'order.base.product.status',
    STOCKTYPE: 'order.base.product.stocktype',
    // SUPPLIERCODE: 'order.base.product.suppliercode', // Replaced by aimeos update -> supplierid
    SUPPLIERID: 'order.base.product.supplierid',
    TAXRATE: 'order.base.product.taxrate',
    TAXRATES: 'order.base.product.taxrates',
    TIMEFRAME: 'order.base.product.timeframe',
    TYPE: 'order.base.product.type',
    BRAND: 'order.base.product.brand',
    BIDEX_SEGMENT: 'order.base.product.bidexsegment',
    DP_STATUS: 'status',
    DP_STOCK_LEVEL: 'stockLevel',
    PAYMENT_TERMS: 'paymentTerms',
    DELIVERY_TERMS: 'deliveryTerms',
    ATTRIBUTES: {
      CODE: 'order.base.product.attribute.code',
      ID: 'order.base.product.attribute.id',
      NAME: 'order.base.product.attribute.name',
      QUANTITY: 'order.base.product.attribute.quantity',
      TYPE: 'order.base.product.attribute.type',
      VALUE: 'order.base.product.attribute.value',
    },
  },
  SUPPLIER_CODE_REGEX: {
    BIKE: /^bike_/,
    SPAREPART: /^sparepart_/,
    ACCESSORY: /^accessory_/,
  },
  ARTICLE_TYPES: {
    BIKE: 'Bike',
    SPAREPART: 'Spareparts',
    ACCESSORY: 'Accessory',
  },
}

export const PATHS = {
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  PRODUCTID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRODUCTID],
  PRODUCTCODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRODUCTCODE],
  NAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.NAME],
  PRICE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PRICE],
  COSTS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COSTS],
  REBATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.REBATE],
  MEDIAURL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.MEDIAURL],
  QUANTITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.QUANTITY],
  POSITION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSITION],
  DESCRIPTION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DESCRIPTION],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  STOCKTYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STOCKTYPE],
  // SUPPLIERCODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SUPPLIERCODE], // Replaced by aimeos update -> supplierid
  SUPPLIERID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SUPPLIERID],
  TAXRATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXRATE],
  TAXRATES: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TAXRATES],
  TIMEFRAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TIMEFRAME],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
}

export default {
  ...CONSTANTS,
  PATHS,
}
